import { render, staticRenderFns } from "./load-template.vue?vue&type=template&id=6f220b79&scoped=true"
import script from "./load-template.vue?vue&type=script&lang=js"
export * from "./load-template.vue?vue&type=script&lang=js"
import style0 from "./load-template.vue?vue&type=style&index=0&id=6f220b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f220b79",
  null
  
)

export default component.exports